module.exports = __webpack_public_path__ + "static/cleaner-0b591baf07c8b1c863610c0bfe1b4550.svg";